var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorLicensePlates = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 120 120",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "error-license-plates_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M119 119V1H1v118h118Z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#error-license-plates_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M60 39.836c-2.9 0-5.273 2.373-5.273 5.274V67.03c0 2.9 2.373 5.274 5.273 5.274 2.9 0 5.273-2.373 5.273-5.274V45.11c0-2.9-2.373-5.274-5.273-5.274ZM65.273 84.61a5.273 5.273 0 1 0-10.546-.001 5.273 5.273 0 0 0 10.546 0Z",
  fill: "#88CA11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.976 86.996 73.555 16.683c-2.77-4.59-7.803-7.66-13.555-7.66s-10.785 3.07-13.555 7.66L4.024 86.996a15.745 15.745 0 0 0-2.266 8.16c0 8.738 7.083 15.821 15.82 15.821h84.844c8.737 0 15.82-7.083 15.82-15.82 0-2.986-.828-5.778-2.266-8.161Z",
  stroke: "#88CA11",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.449 60.298 13.054 92.445a5.174 5.174 0 0 0-.75 2.711 5.28 5.28 0 0 0 5.274 5.274h84.844a5.28 5.28 0 0 0 5.273-5.274c0-.975-.252-1.887-.749-2.712L64.524 22.132A5.246 5.246 0 0 0 60 19.57a5.247 5.247 0 0 0-4.524 2.562L36.08 54.278",
  stroke: "#88CA11",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export { SvgErrorLicensePlates as ReactComponent };
export default __webpack_public_path__ + "/assets/85094299f6cfea7277691ccfcf6fa732.svg";